var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0275B6",
    fillRule: "evenodd",
    d: "M8.942 4C6.395 4 4.085 5.403 2.38 7.682c-.139.186-.139.447 0 .634C4.085 10.597 6.395 12 8.942 12c2.548 0 4.858-1.403 6.563-3.682.139-.186.139-.447 0-.634C13.8 5.403 11.49 4 8.942 4zm.183 6.817c-1.69.107-3.087-1.296-2.98-3.001C6.23 6.41 7.362 5.271 8.76 5.183c1.69-.107 3.087 1.296 2.98 3.001-.09 1.403-1.221 2.542-2.615 2.633zm-.084-1.302c-.911.058-1.664-.697-1.604-1.614.046-.757.657-1.37 1.41-1.42.911-.057 1.664.698 1.604 1.615-.05.76-.66 1.373-1.41 1.42z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.10ddf10334c721fa064a13ffe30156d4.svg";
export { ForwardRef as ReactComponent };